import http from "@/common/http.service";
const ROOT_URL = "contacts/lists";
const DELETE_URL = "contacts/deletelist";
const REFRESH_URL = "contacts/updateActiveCounts";
const RESTART_URL = "contacts/restartcrone";
const RENAME_URL = "contacts/editList";
const SINGLE_LIST = "contacts/singlelist";
const CONTACT_EXPORT = "contacts/exportlist";
const LOGS_URL = "contacts/logs";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.list_data,
        total: response.data.list_count,
        total_listfoud: response.data.client_lists,
        import_process: response.data.import_process,
        deleted_email: response.data.deleted_email
          ? response.data.deleted_email
          : 0,
      };
      cb(data);
    });
  },
  listlogs(params, cb) {
    http.post(LOGS_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
  refresh(id) {
    return http.post(REFRESH_URL, { id: id });
  },
  restartCron(id) {
    return http.post(RESTART_URL, { id: id });
  },
  rename(params) {
    return http.post(RENAME_URL, params);
  },

  getSigleListDetails(params) {
    return http.post(SINGLE_LIST, params);
  },

  contactExport(params) {
    return http.post(CONTACT_EXPORT, params);
  },
};
